var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreening(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E3F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9416 18.233L17.2149 16.5063C17.9642 15.5762 18.3283 14.3942 18.2323 13.2037C18.1363 12.0132 17.5875 10.9048 16.6989 10.1068C15.8103 9.30872 14.6495 8.88176 13.4556 8.91379C12.2617 8.94582 11.1254 9.4344 10.2809 10.2789C9.43636 11.1235 8.94777 12.2597 8.91574 13.4536C8.88371 14.6476 9.31068 15.8083 10.1087 16.6969C10.9068 17.5855 12.0152 18.1343 13.2056 18.2303C14.3961 18.3263 15.5781 17.9622 16.5083 17.213L18.2283 18.9396C18.3231 19.0337 18.4513 19.0864 18.5849 19.0864C18.7185 19.0864 18.8467 19.0337 18.9416 18.9396C19.0352 18.8459 19.0878 18.7188 19.0878 18.5863C19.0878 18.4538 19.0352 18.3267 18.9416 18.233Z",
    fill: "#5FC7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreening);
export default __webpack_public_path__ + "static/media/screening.fa3462164b19019417fe634cfc6d4397.svg";
export { ForwardRef as ReactComponent };